var map = {
	"./bash": 1758,
	"./java": 1759,
	"./json": 1760,
	"./julia": 1761,
	"./python": 1762,
	"./r": 1763,
	"./rust": 1764,
	"./scala": 1765,
	"./shell": 1766,
	"./sql": 1767,
	"./xml": 1768,
	"./yaml": 1769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1757;